"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = AdditionalEquipimentCarousel;
var _react = _interopRequireDefault(require("react"));
var _configuratorCarousel = require("@mmc/configurator-carousel");
function AdditionalEquipimentCarousel(_ref) {
  var theme = _ref.theme,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data;
  return data.items ? /*#__PURE__*/_react["default"].createElement(_configuratorCarousel.ConfiguratorCarousel, {
    theme: theme,
    data: data
  }) : null;
}